import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';  // Import ThemeProvider
import theme from './theme';                            // Import your custom theme
import App from './App';

const container = document.getElementById('dce-admin-root');
const root = createRoot(container);
root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);
